export default __webpack_public_path__ + "static/cekmekoy-rest-1-116171b6727bc0b3fd41d1d44ff7896a.jpg";